import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICompanyForm, ICredentials, IPersonForm, IResetPasswordForm, INewPasswordForm } from '../interfaces';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  readonly url='https://us-central1-residuoscriativos.cloudfunctions.net/app';
  readonly token = localStorage.getItem('token');
  readonly headersWithToken = new HttpHeaders()
    .set('content-type', 'application/json')
    .set('x-access-token', this.token);

  constructor(private http: HttpClient, private router: Router) { }

  authenticate(credentials: ICredentials){
    const headers= new HttpHeaders()
    .set('content-type', 'application/json')
    .set('Access-Control-Allow-Origin', '*');

    return this.http.post(`${this.url}/login`, credentials, {headers: headers});
  }

  logout() {
    localStorage.removeItem('email');
    localStorage.removeItem('cnpj');
    localStorage.removeItem('cpf');
    localStorage.removeItem('token');
    localStorage.removeItem('phone');
    
    this.router.navigate(['/']);
  }

  create(user: IPersonForm | ICompanyForm) {
    return this.http.post(`${this.url}/user`, user);
  }

  resetPassword(form: IResetPasswordForm) {
    return this.http.post(`${this.url}/password/reset`, form);
  }

  newPassword(token: string, email: string, form: INewPasswordForm) {
    return this.http.post(`${this.url}/password/reset/newpass/${email}/${token}`, form);
  }
}